import { MenuSplitButton, ToggleButton, ToggleButtonGroup } from '@atoms/buttons';
import { Box, PrimaryPaper } from '@atoms/layout';
import { Skeleton, Stack, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

const CHART_PAGES = [
  {
    id: 'apps-activity',
    title: 'Apps Activity',
    chartLink: 'https://app.amplitude.com/analytics/share/embed/756bf217-1226-4b0f-829b-d1fff2a52b3f',
  },
];

export function AnalyticsPageLayout() {
  const { id } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();

  const chartToShow = CHART_PAGES.find((page) => page.id === id)?.chartLink;

  const localizationSubset = 'clients';

  return (
    <>
      <Stack
        aria-label="ClientsPageLayoutWrapper"
        spacing={2}
        direction={'column'}
        sx={{ height: '100%', width: '100%' }}
      >
        <Stack direction={'row'} spacing={1} aria-label="ClientsPageHeader">
          <ToggleButtonGroup aria-label="ClientsSubPageSwitcher" value={id}>
            {CHART_PAGES.map((page) => (
              <ToggleButton value={page.id} size="large" onClick={() => navigate(`/analytics/${page.id}`)}>
                {page.title}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          <Box flex={1} />
        </Stack>
        <PrimaryPaper sx={{ height: '100%', minHeight: 0, mt: 2 }}>
          <iframe
            className="frame"
            src={chartToShow}
            style={{
              border: 'none',
              width: '100%',
              height: '500px',
            }}
          />
        </PrimaryPaper>
      </Stack>
    </>
  );
}
